<template>
	<dl id="sellYmd" class="sellYmd sort-item"  v-if="ptInitData.productInfo.YOYAKU_ITEM_FLG == 1">
		<dt>{{$t('pt125.labels.releaseDate')}}</dt>
		<dd>{{ptInitData.productInfo.SELL_YMD}}</dd>
	</dl>
</template>
<script>
	export default {
		name: 'sellYmd',
		props: {
			ptInitData: {
				type: Object,
				default: null,
			}
		}
	}
</script>